<div class="db-available-plugin se-available-10web-product-item"
     [ngClass]="{'db-available-plugin_highlight': activeTab === '10web' && (product.selected || (ongoingActivity$ | async)), 'db-available-plugin_extension': product.type === ProductType.ADD_ON}"
>
  <div class="db-available-plugin__checkbox" [ngClass]="{'db-available-plugin__checkbox-premium': product.type === ProductType.ADD_ON && !product.paidVersionAvailable}" >
    <label class="db-fc-checkbox db-available-plugin__checkbox-item" [ngClass]="{'hide': activeTab !== '10web' || !isManagable || (product.slug ==='tenweb-builder' && !product.paidVersionAvailable)}" *ngIf="!(product.type === ProductType.ADD_ON && !product.paidVersionAvailable && !(product.availableForHosting && website.domain_hash))">
      <input id="availablePlugin_{{product.slug}}" type="checkbox" [(ngModel)]="product.selected" (change)="onItemToggled()">
      <span><i class="db-icon db-icon-check"></i></span>
    </label>
  </div>


  <label class="db-available-plugin__extensions-toggle" *ngIf="hasExtensions">
    <input type="checkbox" [(ngModel)]="product.childrenToggled">
    <a>
      <span>{{displayTitle + ' ' + ('text_plugin-extensions' | dbText)}}</span>
      <i class="db-icon db-icon-arrow-down"></i>
    </a>
  </label>

  <label class="db-available-plugin__logo" *ngIf="!featuredPlugin" [ngClass]="{'db-available-plugin__logo-wp': product.origin !== '10web'}" for="availablePlugin_{{product.slug}}" [ngStyle]="{backgroundImage: 'url(' + product.logo + ')'}"></label>
  <label class="db-available-plugin__logo" *ngIf="featuredPlugin" [ngClass]="{'db-available-plugin__logo-wp': product.origin !== '10web'}" for="availablePlugin_{{product.slug}}" [ngStyle]="{backgroundImage: 'url(../../../../assets/images/logos/featured_plugin.svg)'}"></label>

  <label class="db-available-plugin__main-content" for="availablePlugin_{{product.slug}}">
    <div class="db-available-plugin__title">
      <div [dbTooltip]="activeTab === 'featured-plugins' && featuredPlugin ? ('text_featuredPluginTitle' | dbText) : displayTitle">
        <a href="https://wordpress.org/plugins/{{product.slug}}" target="_blank" rel="noopener" class="db-link_default db-available-plugin__wp-title" *ngIf="activeTab === 'wordpress' || (activeTab === 'featured-plugins' && !featuredPlugin)" [innerHTML]="displayTitle"></a>
        <a href="https://portal.webarxsecurity.com/register" target="_blank" rel="noopener" class="db-link_default db-available-plugin__wp-title" *ngIf="activeTab === 'featured-plugins' && featuredPlugin" [innerHTML]="'text_featuredPluginTitle' | dbText"></a>
        <span class="db-available-plugin__wp-title" *ngIf="activeTab === '10web' && product.slug !='tenweb-speed-optimizer' && product.author && product.author.toLowerCase().includes('10web')">{{displayTitle}}</span>
        <a  class="db-link_default db-available-plugin__wp-title" *ngIf="activeTab === '10web' && product.slug !='tenweb-speed-optimizer' && (!product.author || !product.author.toLowerCase().includes('10web'))">{{displayTitle}}</a>
        <span class="db-available-plugin__wp-title" *ngIf="activeTab === '10web' && product.slug === 'tenweb-speed-optimizer' && product.author && product.author.toLowerCase().includes('10web')">{{displayTitle}}</span>
        <a href="https://10web.io/wordpress-speed-optimization" target="_blank" rel="noopener" class="db-link_default db-available-plugin__wp-title" *ngIf="activeTab === '10web' && product.slug === 'tenweb-speed-optimizer' && (!product.author || !product.author.toLowerCase().includes('10web'))">{{displayTitle}}</a>
      </div>
      <db-rating-stars [rating]="product.rating" *ngIf="!featuredPlugin"></db-rating-stars>
    </div>

    <div class="db-available-plugin__description" *ngIf="!featuredPlugin" [dbTooltip]="displayDescription" [dbTooltipPosition]="'top'" [dbTooltipDelay]="200" [innerHTML]="displayDescription"></div>
    <div class="db-available-plugin__description" *ngIf="featuredPlugin" [dbTooltip]="'text_featuredPluginDesc' | dbText" [dbTooltipPosition]="'top'" [dbTooltipDelay]="200" [innerHTML]="'text_featuredPluginDesc' | dbText"></div>

    <div class="db-available-plugin__active-installs" *ngIf="product.activeInstalls && !featuredPlugin">
      <strong>{{product.activeInstalls | number:'.0' | replaceCommas}}+</strong>
      <span>{{'text_activeInstallsText' | dbText}}</span>
    </div>
  </label>

  <div class="db-available-plugin__info">
    <div>
      <span>{{'text_authorText' | dbText}}: </span>
      <strong>{{featuredPlugin ? ('text_featuredPluginAuthor' | dbText) : displayAuthor}}</strong>
    </div>

    <div *ngIf="product.lastUpdated && !featuredPlugin">
      <span>{{'text_lastUpdatedText' | dbText}}: </span>
      <strong>{{product.lastUpdated | timeFromNow}}</strong>
    </div>
    <div *ngIf="product.requiredWordpressVersion && !featuredPlugin" class="db-product-item__compatible" [innerHTML]="'text_compatible' | dbText: { compatible: product.requiredWordpressVersion}"></div>

  </div>

  <div class="db-available-plugin__action-progress" *ngIf="(ongoingActivity$ | async) && !featuredPlugin">
    <div *ngIf="(ongoingActivity$ | async)">
      <div>
        <div>
          <span *ngIf="((ongoingActivity$ | async).status === ActivityStatus.PENDING || (ongoingActivity$ | async).status === ActivityStatus.RUNNING) && ((ongoingActivity$ | async).action === ActivityAction.INSTALL || (ongoingActivity$ | async).action === ActivityAction.INSTALL_ACTIVATE)">{{'text_installing' | dbText}}</span>
          <span *ngIf="((ongoingActivity$ | async).status === ActivityStatus.PENDING || (ongoingActivity$ | async).status === ActivityStatus.RUNNING) && ((ongoingActivity$ | async).action === ActivityAction.ACTIVATE)">{{'text_activateProcess' | dbText}}</span>
          <span *ngIf="((ongoingActivity$ | async).status === ActivityStatus.PENDING || (ongoingActivity$ | async).status === ActivityStatus.RUNNING) && ((ongoingActivity$ | async).action === ActivityAction.DEACTIVATE)">{{'text_deactivateProcess' | dbText}}</span>
          <span *ngIf="((ongoingActivity$ | async).status === ActivityStatus.PENDING || (ongoingActivity$ | async).status === ActivityStatus.RUNNING) && ((ongoingActivity$ | async).action === ActivityAction.DEACTIVATE_DELETE)">{{'text_deleteProcess' | dbText}}</span>
          <span *ngIf="(ongoingActivity$ | async).status === ActivityStatus.DONE || ActivityStatus.FAILED">{{(ongoingActivity$ | async).message}}</span>
        </div>

        <div><db-progress-bar size="sm" [state]="ongoingActivityStatusClass$ | async" [progressPercent]="(ongoingActivity$ | async).progress"></db-progress-bar></div>
      </div>
    </div>
  </div>

  <div class="db-available-plugin__buttons" *ngIf="!(ongoingActivity$ | async) || featuredPlugin" [ngClass]="{'db-available-plugin__one-button': !(product.type === ProductType.PLUGIN && !product.paidVersionInstalled && !product.paidVersionAvailable && activeTab === '10web') || (product.availableForHosting && website.domain_hash && activeTab === '10web' && !(product.type === ProductType.PLUGIN && activeTab === '10web' && (product.availableForHosting && website.domain_hash) && product.installed && !product.paidVersionInstalled))}">

    <a class="db-button db-button_lg db-button_success"
       [ngClass]="{'db-button_disabled': (ongoingActivity$ | async) || !isManagable || product.paidVersionInstalled}"
       (click)="installPaidVersion()"
       *ngIf="product.type === ProductType.PLUGIN && product.availableForHosting && website.domain_hash && activeTab === '10web'"
    >
      <span>{{(product.paidVersionInstalled ? 'text_premiumInstalled' : 'text_installPremium') | dbText}}</span>
    </a>

    <a class="db-button db-button_info db-button_lg sl-install-10web"
       [ngClass]="{'db-button_disabled': product.installed || (ongoingActivity$ | async) || !isManagable, 'db-button_premium': (product.paidVersionAvailable && !product.installed) || product.paidVersionInstalled}"
       (click)="installPaidVersion()"
       *ngIf="product.type === ProductType.PLUGIN && activeTab === '10web' && (product.availableForHosting && website.domain_hash) && product.installed && !product.paidVersionInstalled"
    >
      <span>{{ 'text_installed' | dbText}}</span>
    </a>

    <a class="db-button db-button_lg db-button_success sl-update-10web"
       [ngClass]="{'db-button_disabled': product.paidVersionInstalled || (ongoingActivity$ | async) || !isManagable}"
       (click)="showPremiumPluginDialog(product)"
       *ngIf="product.type === ProductType.PLUGIN && !product.paidVersionInstalled && !product.paidVersionAvailable && activeTab === '10web' && !(product.availableForHosting && website.domain_hash)"
    >
      <span>{{(!product.installed ? 'text_getPremium' : 'text_upgradePremium' ) | dbText}}</span>
    </a>
    <a class="db-button db-button_lg db-button_success"
       [ngClass]="{'db-button_disabled': (ongoingActivity$ | async) || !isManagable}"
       (click)="installPaidVersion()"
       *ngIf="product.type === ProductType.PLUGIN && !product.paidVersionInstalled && product.installed && product.paidVersionAvailable && activeTab === '10web' && !(product.availableForHosting && website.domain_hash)"
    >
      <span>{{'text_installPremium' | dbText}}</span>
    </a>
    <a class="db-button db-button_info db-button_lg sl-install-10web"
       [ngClass]="{'db-button_disabled': product.installed || (ongoingActivity$ | async) || !isManagable, 'db-button_premium': (product.paidVersionAvailable && !product.installed) || product.paidVersionInstalled}"
       (click)="installAndActivate()"
       *ngIf="product.type === ProductType.PLUGIN && activeTab === '10web' && !(product.availableForHosting && website.domain_hash)"
    >
      <span>{{(product.installed ? (!product.paidVersionInstalled ? 'text_installed' : 'text_premiumInstalled') : !product.paidVersionAvailable ? 'text_installFree' : 'text_installPremium') | dbText}}</span>
    </a>
    <a class="db-button db-button_info db-button_lg sl-install-wordpress"
       [ngClass]="{'db-button_disabled': (isWpProductInstalled$ | async) || (ongoingActivity$ | async) || !isManagable}"
       (click)="installAndActivate()"
       *ngIf="product.type === ProductType.PLUGIN && (activeTab === 'wordpress' || activeTab === 'featured-plugins' && !featuredPlugin)"
    >
      <span>{{((isWpProductInstalled$ | async) ? 'text_installed' : 'text_install') | dbText}}</span>
    </a>
    <a class="db-button db-button_info db-button_lg sl-install-wordpress"
       href="https://portal.webarxsecurity.com/register" target="_blank" rel="noopener"
       *ngIf="product.type === ProductType.PLUGIN && activeTab === 'featured-plugins' && featuredPlugin"
    >
      <span>{{'text_getNow' | dbText}}</span>
    </a>

    <a class="db-link db-link_sm"
       [ngClass]="{'db-link_disabled': product.installed || (ongoingActivity$ | async) || !isManagable}"
       (click)="installAndActivate()"
       *ngIf="product.type === ProductType.ADD_ON && ((product.hasPaidVersion && !(product.availableForHosting && website.domain_hash)) || (product.availableForHosting && website.domain_hash))"
    >
      <span>{{(product.installed ? 'text_installed' : 'text_install') | dbText}}</span>
    </a>
    <a class="db-link db-user-premium"
       [ngClass]="{'db-link_disabled': product.installed || (ongoingActivity$ | async) || !isManagable}"
       (click)="showPremiumPluginDialog(parent)"
       *ngIf="product.type === ProductType.ADD_ON && !product.hasPaidVersion && !(product.availableForHosting && website.domain_hash)"
       [innerHTML]="'text_availableInPremium' | dbText"
    >
    </a>
  </div>
</div>

